const { translateString } = window.BAO.Utils
const KeenSlider = window.KeenSlider
const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class TagalysQuickSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.element) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()
    if (!window?.onTagalysReady) return

    this.initialise = this.initialise.bind(this)
    this.updateSearchSuggestions = this.updateSearchSuggestions.bind(this)
    this.buildProductResults = this.buildProductResults.bind(this)
    this.onClearClick = this.onClearClick.bind(this)
    this.renderPopularSearches = this.renderPopularSearches.bind(this)

    this.els?.input?.element.addEventListener(
      'input',
      this.updateSearchSuggestions,
    )

    this.els?.clear?.element?.addEventListener('click', this.onClearClick)
    this.els?.close?.element?.addEventListener('click', this.onClearClick)

    this.els?.input?.element?.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.onClearClick(e)
    })

    // eslint-disable-next-line no-undef
    onTagalysReady(this.initialise)
  }

  initialise () {
    // eslint-disable-next-line no-undef
    window.searchSuggestions = Tagalys.APIConnector.SearchSuggestions.new({
      params: {
        query: this.els?.input?.element.value,
        sections: {
          products: {
            include: ['total_count', 'items'],
            count: 6,
          },
          collections: {
            count: 5,
          },
        },
      },
      onSuccess: (response) => {
        this.buildProductResults(this.els?.products?.element, response)
        this.buildCollectionResults(this.els?.collections?.element, response)
      },
      onFailure (response, helpers) {
        console.error('Failed response:', response)
        console.error('Failed helpers:', helpers)
      },
    })

    this.renderPopularSearches()
  }

  setState (state) {
    if (this.getAttribute('data-state') !== state) {
      this.setAttribute('data-state', state)
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els?.slide?.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 2,
              spacing: 32,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  updateSearchSuggestions (event) {
    const query = event.target.value || ''
    this._currentQuery = query.trim()
    window.searchSuggestions?.helpers.updateQuery(query)

    this.els?.clear?.element.setAttribute(
      'aria-hidden',
      this._currentQuery.length < 3,
    )

    if (this._currentQuery.length < 3) {
      this.setState('default')

      this.els?.['suggestion-popular']?.element?.setAttribute(
        'aria-hidden',
        false,
      )
      this.els?.['suggestion-collections']?.element?.setAttribute(
        'aria-hidden',
        true,
      )
      this.els?.['suggestion-pages']?.element?.setAttribute(
        'aria-hidden',
        false,
      )

      this.els?.['products-container']?.element?.setAttribute(
        'aria-hidden',
        true,
      )
      this.els?.products?.element && (this.els.products.element.innerHTML = '')
    }
  }

  onClearClick () {
    if (!this.els?.input?.element) return

    this.els.input.element.value = ''
    this._currentQuery = ''
    this._lastRecordedQuery = ''

    window.searchSuggestions?.helpers.updateQuery('')

    this.els.clear.element.setAttribute('aria-hidden', true)
    this.els?.products?.element && (this.els.products.element.innerHTML = '')
    this.els?.collections?.element &&
      (this.els.collections.element.innerHTML = '')

    this.els?.['products-container']?.element?.setAttribute(
      'aria-hidden',
      true,
    )
    this.els?.['suggestion-collections']?.element?.setAttribute(
      'aria-hidden',
      true,
    )
    this.els?.['suggestion-popular']?.element?.setAttribute(
      'aria-hidden',
      false,
    )
    this.els?.['suggestion-pages']?.element?.setAttribute('aria-hidden', false)

    this.setState('default')

    this.els.input.element.focus()
  }

  getEncodedQueryStringFromTagalys (query) {
    const helpers = window.searchSuggestions?.helpers
    const searchQuery = query

    return helpers.getEncodedQueryString({ query: searchQuery })
  }

  buildResultsHref (encodedQueryString, redirectToUrl) {
    if (redirectToUrl) {
      try {
        return `${redirectToUrl}`
      } catch (error) {
        console.error('Failed to parse redirect_to_url:', redirectToUrl, error)
      }
    }

    if (!encodedQueryString) return null

    return `${this.searchPath}?${encodedQueryString}`
  }

  buildSearchLink (queryString) {
    if (typeof queryString !== 'string' || !queryString) return null

    return `${this.searchPath}?${queryString}`
  }

  escapeHtml (s) {
    return String(s)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;')
  }

  buildListMarkupFromQueries (items = []) {
    return items
      .map(({ title, queryString, link }) => {
        const rawHref = link || this.buildSearchLink(queryString)
        if (!rawHref) return ''

        const href = rawHref.startsWith('http')
          ? rawHref.replace(
            window.location.origin,
              `${window.location.origin}${this.localePrefix}`,
          )
          : `${this.localePrefix}${rawHref}`

        return `
        <li class="drw-QuickSearch_SuggestionItem">
          <a href="${href}" class="drw-QuickSearch_SuggestionLink btn-Border fz-14_140">${this.escapeHtml(title || '')}</a>
        </li>
      `
      })
      .join('')
  }

  buildCollectionResults (container, response) {
    if ((this._currentQuery || '').length < 3) return ''

    const items = Array.isArray(response.sections?.collections?.items)
      ? response.sections?.collections.items
      : []
    const html = this.buildListMarkupFromQueries(items)

    if (items.length > 1) {
      container.innerHTML = html
      this.els?.['suggestion-collections']?.element?.setAttribute(
        'aria-hidden',
        !items.length,
      )

      this.els?.['suggestion-popular']?.element?.setAttribute(
        'aria-hidden',
        true,
      )
    }

    return html
  }

  async renderPopularSearches () {
    const container = this.els?.popular?.element
    if (!container) return

    try {
      const popular =
        await window.searchSuggestions.helpers.getPopularSearches(5)
      const html = this.buildPopularSearchesMarkup(popular)

      container.innerHTML = html

      this.els?.['suggestion-popular']?.element?.setAttribute(
        'aria-hidden',
        !popular?.length,
      )
    } catch (error) {
      this.handleError?.(error)
    }
  }

  buildPopularSearchesMarkup (items = []) {
    return items
      .map(({ query }) => {
        if (!query) return ''

        const queryString =
          window.searchSuggestions.helpers.getEncodedQueryString({ query })
        const href = `${this.searchPath}?${queryString}`

        return `
        <li class="drw-QuickSearch_SuggestionItem">
          <a href="${href}" class="drw-QuickSearch_SuggestionLink btn-Border fz-14_140">${this.escapeHtml(query)}</a>
        </li>
      `
      })
      .join('')
  }

  async buildProductResults (container, response) {
    const productsContainer = this.els?.['products-container']?.element
    if (!productsContainer) return ''

    const current = this._currentQuery || ''

    if (current.length < 3) {
      container.innerHTML = ''
      productsContainer.setAttribute('aria-hidden', true)
      productsContainer.removeAttribute('aria-busy')
      this.setState('default')
      return ''
    }

    productsContainer.setAttribute('aria-hidden', false)
    productsContainer.setAttribute('aria-busy', 'true')

    const queryAtStart = current

    const productResultsHtml = await this.createProductCards(
      response.sections.products.items,
    )

    if (
      this._currentQuery !== queryAtStart ||
      (this._currentQuery || '').length < 3
    ) {
      productsContainer.setAttribute('aria-hidden', true)
      productsContainer.removeAttribute('aria-busy')
      this.setState('default')
      return ''
    }

    container.innerHTML = productResultsHtml

    await this.updateRegiosPrices()

    window.yotpoWidgetsContainer?.initWidgets()

    const resultsTotal = response?.sections?.products?.total_count || 0
    const redirectToUrl = response?.metadata?.redirect_to_url
    const encodedQuery = this.getEncodedQueryStringFromTagalys(current)
    const buttonHref = this.buildResultsHref(encodedQuery, redirectToUrl)

    if (resultsTotal > 0) {
      this.els['link-text'].element.innerHTML = translateString(
        this.translations?.quickSearch?.resultsCount,
        { count: `${resultsTotal}` },
      )
      this.els['products-link'].element.setAttribute('href', buttonHref)

      this.els?.['suggestion-pages']?.element?.setAttribute(
        'aria-hidden',
        true,
      )

      this.setState('results')
    } else {
      this.els['no-results'].element.innerHTML = translateString(
        this.translations?.quickSearch?.noResults,
        { terms: `${current}` },
      )

      this.setState('no-results')
      if (!productResultsHtml.trim()) {
        productsContainer.setAttribute('aria-hidden', true)
      }
    }

    productsContainer.removeAttribute('aria-busy')

    return productResultsHtml
  }

  async createProductCards (products) {
    const cards = await Promise.all(
      products.map(async (product) => {
        const productUrl = `${window.Shopify.routes.root}products/${product.handle}`

        try {
          const res = await window.BAO.sectionRenderer.fetchSingle(
            'tagalys-product-card',
            productUrl,
          )
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const article = newDOM.querySelector('article')

          return article
            ? `
              <div class="drw-QuickSearch_QueryItem">
                ${article.outerHTML}
              </div>`
            : ''
        } catch (error) {
          this.handleError(error)
          return ''
        }
      }),
    )

    return cards.join('')
  }

  async updateRegiosPrices () {
    const productElements = this.els?.products?.element?.querySelectorAll(
      '[data-regios-dopp-generic-product-id]',
    )

    if (!productElements || productElements.length === 0) return

    const api = await this.getRegiosApi()

    if (!api) return

    const calculations = new Map()

    for (const productElement of productElements) {
      const dataElement = productElement.querySelector('[data-regios-product]')

      if (!dataElement) continue

      let product

      try {
        product = JSON.parse(dataElement.textContent)
      } catch (error) {
        console.warn(
          '[TagalysQuickSearch] Could not parse Regios product data',
          error,
        )

        continue
      }

      if (!calculations.has(product.productId)) {
        calculations.set(
          product.productId,
          api.calculateDiscountedPrices(product),
        )
      }

      const priceContainer = productElement.querySelector(
        '.regios-dopp-generic-price-container',
      )
      const salePriceElement = priceContainer?.querySelector(
        '.regios-dopp-generic-price-item--sale',
      )
      const regularPriceElement = priceContainer?.querySelector(
        '.regios-dopp-generic-price-item--regular',
      )

      if (!priceContainer || !salePriceElement || !regularPriceElement) {
        continue
      }

      try {
        const { salePrice, regularPrice } = await calculations.get(
          product.productId,
        )

        const isDiscounted = salePrice.amount < regularPrice.amount

        this.updatePriceText(salePriceElement, salePrice.formatted)

        if (isDiscounted) {
          this.updatePriceText(regularPriceElement, regularPrice.formatted)

          regularPriceElement.style.removeProperty('display')

          priceContainer.classList.add('regios-dopp-generic-price--on-sale')
        } else {
          this.updatePriceText(salePriceElement, regularPrice.formatted)
          this.updatePriceText(regularPriceElement, '')

          regularPriceElement.style.display = 'none'

          priceContainer.classList.remove('regios-dopp-generic-price--on-sale')
        }
      } catch (error) {
        console.warn(
          `[TagalysQuickSearch] Could not calculate Regios price for product ${product.productId}`,
          error,
        )
      }
    }
  }

  updatePriceText (element, value) {
    const screenReaderElement = element.querySelector('.util-ScreenReaderOnly')

    element.replaceChildren()

    if (screenReaderElement) {
      element.append(screenReaderElement)
    }

    element.append(document.createTextNode(value))
  }

  getRegiosApi () {
    if (window.RegiosDOPP?.api?.v0) {
      return Promise.resolve(window.RegiosDOPP.api.v0)
    }

    return new Promise((resolve) => {
      const timeout = window.setTimeout(() => {
        resolve(null)
      }, 5000)

      window.addEventListener(
        'regios-dopp:api-initialized',
        (event) => {
          window.clearTimeout(timeout)

          resolve(event.detail.api)
        },
        { once: true },
      )
    })
  }

  get localePrefix () {
    const root = window.Shopify?.routes?.root ?? '/'
    return root === '/' ? '' : root.replace(/\/$/, '')
  }

  get searchPath () {
    return `${this.localePrefix}${this.getAttribute('search-path') || '/pages/search'}`
  }

  get translations () {
    return window.theme.strings
  }
}

if (!customElements.get('tagalys-quick-search')) {
  customElements.define('tagalys-quick-search', TagalysQuickSearch)
}
